var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "1D1D26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 9.99986C17.5005 10.1656 17.4346 10.3246 17.3174 10.4418C17.2002 10.559 17.0413 10.6249 16.8755 10.6249H4.63409L9.19268 15.1827C9.25075 15.2407 9.29681 15.3097 9.32824 15.3855C9.35966 15.4614 9.37584 15.5427 9.37584 15.6249C9.37584 15.707 9.35966 15.7883 9.32824 15.8642C9.29681 15.94 9.25075 16.009 9.19268 16.067C9.13461 16.1251 9.06567 16.1712 8.9898 16.2026C8.91393 16.234 8.83261 16.2502 8.75049 16.2502C8.66837 16.2502 8.58705 16.234 8.51118 16.2026C8.43531 16.1712 8.36637 16.1251 8.3083 16.067L2.6833 10.442C2.62519 10.384 2.57909 10.3151 2.54764 10.2392C2.51619 10.1633 2.5 10.082 2.5 9.99986C2.5 9.91772 2.51619 9.8364 2.54764 9.76052C2.57909 9.68465 2.62519 9.61572 2.6833 9.55767L8.3083 3.93267C8.42558 3.8154 8.58464 3.74951 8.75049 3.74951C8.91634 3.74951 9.0754 3.8154 9.19268 3.93267C9.30996 4.04995 9.37584 4.20901 9.37584 4.37486C9.37584 4.54071 9.30996 4.69977 9.19268 4.81705L4.63409 9.37486H16.8755C17.0413 9.37486 17.2002 9.44071 17.3174 9.55792C17.4346 9.67513 17.5005 9.8341 17.5005 9.99986Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.9cec9bd79506689ff0eafc9fe8e79af2.svg";
export { ForwardRef as ReactComponent };